import join from "url-join"

export const PROVIDERS = {
  YOUTUBE: "youtube",
  VIMEO: "vimeo",
  FACEBOOK: "facebook",
  MUX: "mux"
}

export const isVimeo = provider => provider === PROVIDERS.VIMEO
export const isYoutube = provider => provider === PROVIDERS.YOUTUBE
export const isFacebook = provider => provider === PROVIDERS.FACEBOOK
export const isMux = provider => provider === PROVIDERS.MUX

export const appendEmbedParams = (provider, link) => {
  let queryParams =
    provider === PROVIDERS.YOUTUBE
      ? "?modestbranding=1&autohide=1&showinfo=0&rel=0&autoplay=0&iv_load_policy=3&playsinline=1&enablejsapi=1&fs=1"
      : provider === PROVIDERS.VIMEO
      ? "?autoplay=0&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media"
      : ""

  return join(link, queryParams)
}

export const initializeFacebook = callback => {
  const initFbObject = () => {
    window.FB.init({
      appId: process.env.VUE_APP_FACEBOOK_APP_ID,
      xfbml: true,
      version: "v3.2"
    })
  }

  // https://developers.facebook.com/docs/plugins/embedded-video-player/#wordpress
  let js = document.getElementsByTagName("script")[0]
  const fjs = document.getElementsByTagName("script")[0]

  if (document.getElementById("facebook-jssdk")) {
    initFbObject()
    callback()
    return
  }

  js = document.createElement("script")
  js.id = "facebook-jssdk"
  js.onload = () => {
    setTimeout(() => {
      initFbObject()
      callback()
    }, 250)
  }

  js.src = "https://connect.facebook.net/en_US/sdk.js"
  fjs.parentNode.insertBefore(js, fjs)
}

export const generateMuxThumbnailUrl = embedLink => {
  const playbackId = embedLink.split(".com/")[1].split(".")[0]

  return `https://image.mux.com/${playbackId}/thumbnail.png`
}
